var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 3.89648C14.6663 5.03315 13.7405 5.95898 12.6038 5.95898H9.39551C8.82717 5.95898 8.31384 5.72982 7.93801 5.35398C7.56217 4.97815 7.33301 4.46482 7.33301 3.89648C7.33301 2.75982 8.25884 1.83398 9.39551 1.83398H12.6038C13.1722 1.83398 13.6855 2.06315 14.0613 2.43898C14.4372 2.81482 14.6663 3.32815 14.6663 3.89648Z",
    fill: "#818194"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2612 4.61001C17.0503 4.43584 16.812 4.29834 16.5553 4.19751C16.2895 4.09667 16.0237 4.30751 15.9687 4.58251C15.657 6.15001 14.2728 7.33251 12.6045 7.33251H9.39616C8.47949 7.33251 7.61783 6.97501 6.96699 6.32417C6.49033 5.84751 6.16033 5.24251 6.03199 4.59167C5.97699 4.31667 5.70199 4.09667 5.43616 4.20667C4.37283 4.63751 3.66699 5.60917 3.66699 7.56167V16.4992C3.66699 19.2492 5.30783 20.1658 7.33366 20.1658H14.667C16.6928 20.1658 18.3337 19.2492 18.3337 16.4992V7.56167C18.3337 6.06751 17.9212 5.15084 17.2612 4.61001ZM7.33366 11.2283H11.0003C11.3762 11.2283 11.6878 11.54 11.6878 11.9158C11.6878 12.2917 11.3762 12.6033 11.0003 12.6033H7.33366C6.95783 12.6033 6.64616 12.2917 6.64616 11.9158C6.64616 11.54 6.95783 11.2283 7.33366 11.2283ZM14.667 16.27H7.33366C6.95783 16.27 6.64616 15.9583 6.64616 15.5825C6.64616 15.2067 6.95783 14.895 7.33366 14.895H14.667C15.0428 14.895 15.3545 15.2067 15.3545 15.5825C15.3545 15.9583 15.0428 16.27 14.667 16.27Z",
    fill: "#818194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientRecord);
export default __webpack_public_path__ + "static/media/PatientRecord.c07b9c9ce5ca258fef986e28ae108594.svg";
export { ForwardRef as ReactComponent };